import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileSidebarOpen && !event.target.closest("#sidebar")) {
        setIsMobileSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileSidebarOpen]);

  // Toggle mobile sidebar
  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  return (
    <>
      {/* Mobile sidebar toggle button */}
      <button
        onClick={toggleMobileSidebar}
        className="lg:hidden fixed z-50 top-4 left-4 bg-blue-600 text-white p-2 rounded-md shadow-lg"
        aria-label="Toggle sidebar"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      <nav
        id="sidebar"
        className={`bg-gray-900 text-white h-screen fixed top-0 left-0 w-64 shadow-lg transition-transform duration-300 ease-in-out z-40
                   ${
                     isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
                   } lg:translate-x-0`}
      >
        {/* Brand logo wrapper */}
        <div className="h-16 bg-gray-900 flex items-center justify-center border-b border-gray-800 fixed top-0 left-0 w-64 z-10">
          <NavLink
            to="/panel-admin/dashboard"
            className="px-4 hidden lg:flex items-center"
          >
            <img src="https://dummyimage.com/150x150/cccccc/000000&text=Institution+Logo" alt="logo" className="h-10" />
          </NavLink>
          <NavLink
            to="/panel-admin/dashboard"
            className="px-4 flex lg:hidden items-center"
          >
            <img src="https://dummyimage.com/150x150/cccccc/000000&text=Institution+Logo" alt="logo" className="h-8" />
          </NavLink>
        </div>

        {/* Navigation items */}
        <div className="overflow-y-auto h-full pt-16 pb-20">
          <ul className="mt-2">
            <NavItem to="/panel-admin/dashboard" icon="mdi-speedometer">
              Dashboard
            </NavItem>
            <NavItem to="/panel-admin/forms" icon="mdi-file-document">
              Forms
            </NavItem>
            <NavItem to="/panel-admin/leads" icon="mdi-source-branch">
              Lead Links
            </NavItem>
            <NavItem
              to="/panel-admin/admissions-enquiry"
              icon="mdi-account-question"
            >
              Admission Enquiries
            </NavItem>
            <NavItem to="/panel-admin/departments" icon="mdi-domain">
              Departments
            </NavItem>
            <NavItem to="/panel-admin/programs" icon="mdi-book-open-variant">
              Programs
            </NavItem>
            <NavItem to="/panel-admin/batches" icon="mdi-account-group">
              Batches
            </NavItem>
            <NavItem to="/panel-admin/faculties" icon="mdi-teach">
              Faculties
            </NavItem>
            <NavItem
              to="/panel-admin/rubrics-subject"
              icon="mdi-format-list-bulleted-square"
            >
              Rubrics Subject
            </NavItem>
            <NavItem
              to="/panel-admin/subjects"
              icon="mdi-book-open-page-variant"
            >
              Subjects
            </NavItem>
            <NavItem to="/panel-admin/students" icon="mdi-school">
              Students
            </NavItem>
            <NavItem to="/panel-admin/grade-schemes" icon="mdi-certificate">
              Grade Schemes
            </NavItem>
            <NavItem to="/panel-admin/timetable" icon="mdi-calendar-clock">
              TimeTable
            </NavItem>
            <NavItem to="/panel-admin/academic-calender" icon="mdi-calendar">
              Academic Calender
            </NavItem>
            <NavItem to="/panel-admin/notification-center" icon="mdi-bell">
              Notification Center
            </NavItem>
            <NavItem
              to="/panel-admin/feedback"
              icon="mdi-comment-text-multiple"
            >
              <span>
                Subject + Faculty <br /> Feedback
              </span>
            </NavItem>
            <NavItem to="/panel-admin/fee-management" icon="mdi-cash-multiple">
              Fee Management
            </NavItem>
            <NavItem to="/panel-admin/transactions" icon="mdi-cash-register">
              Transactions
            </NavItem>
            <NavItem to="/panel-admin/installment-settings" icon="mdi-credit-card-settings">
              Installment Settings
            </NavItem>
          </ul>
        </div>
      </nav>
    </>
  );
};

const NavItem = ({ to, icon, children }) => {
  return (
    <li className="px-2 py-1">
      <NavLink
        to={to}
        className={({ isActive }) =>
          `flex items-center px-4 py-3 rounded-tr-full rounded-br-full transition-colors ${
            isActive
              ? "bg-blue-700 text-white"
              : "text-gray-300 hover:bg-gray-800"
          }`
        }
      >
        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-800/50 mr-3">
          <i className={`mdi ${icon} text-xl`}></i>
        </span>
        <span className="font-medium text-sm">{children}</span>
      </NavLink>
    </li>
  );
};

export default Navbar;
